import React from "react";
import WagerTypesConstants from "../../constants/WagerTypesConstants";
import TransparentTextInput from "../TransparentTextInput";

const WagerTypesLimitTable = ({
  limitSetBetTypes,
  divRef,
  tableRef,
  setLimitSetBetTypes,
  setHasChanges,
  betTypeOptionSelected,
  setBetTypeOptionSelected,
  setBetTypeName,
}) => {
  let rowsBetTypes,
    headers,
    colsWagerTypes = [];

  //Headers
  headers = (
    <tr className="text-center" style={{ fontWeight: "normal" }}>
      <th hidden>WagerTypeID</th>
      <th style={{ whiteSpace: "normal", verticalAlign: "middle" }}>
        Bet Type
      </th>
      <th style={{ whiteSpace: "normal", verticalAlign: "middle" }}>Enabled</th>
      <th style={{ whiteSpace: "normal", verticalAlign: "middle" }}>
        Min Stake
      </th>
      <th
        style={{
          whiteSpace: "normal",
          width: "180px",
          verticalAlign: "middle",
        }}
      >
        Max Stake
      </th>
      <th
        style={{
          whiteSpace: "normal",
          width: "180px",
          verticalAlign: "middle",
        }}
      >
        Min Stake Online
      </th>
      <th
        style={{
          whiteSpace: "normal",
          width: "180px",
          verticalAlign: "middle",
        }}
      >
        Max Stake Online
      </th>
      <th
        style={{
          whiteSpace: "normal",
          width: "150px",
          verticalAlign: "middle",
        }}
      >
        Max Payout Odds
      </th>
      <th
        style={{
          whiteSpace: "normal",
          width: "150px",
          verticalAlign: "middle",
        }}
      >
        Max Payout Cap
      </th>
      <th
        style={{
          whiteSpace: "normal",
          width: "180px",
          verticalAlign: "middle",
        }}
      >
        Add Payout Odds
      </th>
      <th style={{ whiteSpace: "normal", verticalAlign: "middle" }}>Rebate</th>
      <th style={{ whiteSpace: "normal", verticalAlign: "middle" }}>
        Rebate Online
      </th>
      <th style={{ whiteSpace: "normal", verticalAlign: "middle" }}>
        Tote Bet
      </th>
      <th style={{ whiteSpace: "normal", verticalAlign: "middle" }}>
        Tote Threshold
      </th>
      <th style={{ whiteSpace: "normal", verticalAlign: "middle" }}>
        Accumulative Limit
      </th>
    </tr>
  );

  //Onchange LimitSet Table
  const limitSetTableChangeHandler = (e) => {
    const x = [...limitSetBetTypes];
    const betType = e.target.getAttribute("data-key");
    const index = x.findIndex((item) => item.BetType === parseInt(betType));

    if (index !== -1) {
      const name = e.target.name;
      let value = e.target.value;

      if (!/^\d*\.?\d*$/.test(value)) {
        return;
      }
      // if value is empty, value = "0"
      if (value.trim() === "") {
        value = "0";
      } else {
        // Remove leading zeros, but keep a zero before the decimal point if necessary.
        let parts = value.split(".");

        parts[0] = parts[0] === "0" ? "0" : parts[0].replace(/^0+/, "");

        if (name === "Rebate" || name === "RebateOnline") {
          if (parts[0].length > 3) {
            return;
          }

          if (parts[1]) {
            parts[1] = parts[1].slice(0, 2);
          }

          value = parts[1] !== undefined ? `${parts[0]}.${parts[1]}` : parts[0];

          const numericValue = parseFloat(value);

          if (numericValue > 100) {
            return;
          }
        } else {
          if (parts[0].length > 9) {
            return;
          }

          if (parts[0].length === 9 && !value.includes(".")) {
            if (value.length > 9) {
              return;
            }
          }

          if (parts[1]) {
            parts[1] = parts[1].slice(0, 2);
          }

          value = parts[1] !== undefined ? `${parts[0]}.${parts[1]}` : parts[0];

          const numericValue = parseFloat(value);
          const maxValue = 999999999.99;

          if (numericValue > maxValue) {
            value = "999999999.99";
          }
        }
      }

      const updatedX = [...x];
      updatedX[index] = {
        ...updatedX[index],
        [name]: value,
        Change: true,
      };

      setLimitSetBetTypes(updatedX);
      setHasChanges(true);
    }
  };

  //Onchange Enabled Checkboxes
  const handleChkEnabledChange = (id) => {
    setLimitSetBetTypes((prevState) => {
      const newData = prevState.map((item) => {
        if (item.BetType === parseInt(id)) {
          return {
            ...item,
            BetTypeEnabled: !item.BetTypeEnabled,
            Change: true,
          };
        }
        return item;
      });
      return newData;
    });
    setHasChanges(true);
  };

  //Onchange Enabled Checkboxes
  const handleChkToteBetChange = (id) => {
    setLimitSetBetTypes((prevState) => {
      const newData = prevState.map((item) => {
        if (item.BetType === parseInt(id)) {
          return {
            ...item,
            ToteBet: !item.ToteBet,
            Change: true,
          };
        }
        return item;
      });
      return newData;
    });
    setHasChanges(true);
  };

  //Onchange Enabled Checkboxes
  const handleChkAccumulativeLimitChange = (id) => {
    setLimitSetBetTypes((prevState) => {
      const newData = prevState.map((item) => {
        if (item.BetType === parseInt(id)) {
          return {
            ...item,
            UseAcumulativeLimit: !item.UseAcumulativeLimit,
            Change: true,
          };
        }
        return item;
      });
      return newData;
    });
    setHasChanges(true);
  };

  const setBetTypeInfo = (betTypeID, betTypeName) => {
    setBetTypeOptionSelected(betTypeID);
    setBetTypeName(betTypeName);
  };

  WagerTypesConstants.forEach((element, i) => {
    if (limitSetBetTypes) {
      limitSetBetTypes.forEach((betType) => {
        if (betType.BetType === element.id) {
          rowsBetTypes = (
            <>
              <td
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                  width: "70px",
                }}
              >
                <input
                  key={"BetTypeEnabled" + i}
                  type="checkbox"
                  name="BetTypeEnabled"
                  checked={betType.BetTypeEnabled}
                  style={{ height: "15px", cursor: "pointer" }}
                  className="form-control"
                  onChange={() => handleChkEnabledChange(betType.BetType)}
                ></input>
              </td>
              <td
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                  width: "80px",
                }}
              >
                <TransparentTextInput
                  id="MinStake"
                  name="MinStake"
                  type="text"
                  dataKey={betType.BetType}
                  onChange={limitSetTableChangeHandler}
                  value={betType.MinStake}
                  fontSize="12px"
                  width={"80px"}
                />
              </td>
              <td
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                  width: "80px",
                }}
              >
                <TransparentTextInput
                  id="MaxStake"
                  name="MaxStake"
                  type="text"
                  dataKey={betType.BetType}
                  onChange={limitSetTableChangeHandler}
                  value={betType.MaxStake}
                  fontSize="12px"
                  width={"80px"}
                />
              </td>
              <td
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                <TransparentTextInput
                  id="MinStakeOnline"
                  name="MinStakeOnline"
                  type="text"
                  dataKey={betType.BetType}
                  onChange={limitSetTableChangeHandler}
                  value={betType.MinStakeOnline}
                  fontSize="12px"
                  width={"80px"}
                />
              </td>
              <td
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                <TransparentTextInput
                  id="MaxStakeOnline"
                  name="MaxStakeOnline"
                  type="text"
                  dataKey={betType.BetType}
                  onChange={limitSetTableChangeHandler}
                  value={betType.MaxStakeOnline}
                  fontSize="12px"
                  width={"80px"}
                />
              </td>
              <td
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                <TransparentTextInput
                  id="MaxPayoutOdds"
                  name="MaxPayoutOdds"
                  type="text"
                  dataKey={betType.BetType}
                  onChange={limitSetTableChangeHandler}
                  value={betType.MaxPayoutOdds}
                  fontSize="12px"
                  width={"80px"}
                />
              </td>
              <td
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                <TransparentTextInput
                  id="MaxPayoutCap"
                  name="MaxPayoutCap"
                  type="text"
                  dataKey={betType.BetType}
                  onChange={limitSetTableChangeHandler}
                  value={betType.MaxPayoutCap}
                  fontSize="12px"
                  width={"80px"}
                />
              </td>
              <td
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                <TransparentTextInput
                  id="AddPayoutOdds"
                  name="AddPayoutOdds"
                  type="text"
                  dataKey={betType.BetType}
                  onChange={limitSetTableChangeHandler}
                  value={betType.AddPayoutOdds}
                  fontSize="12px"
                  width={"80px"}
                />
              </td>
              <td
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                <TransparentTextInput
                  id="Rebate"
                  name="Rebate"
                  type="text"
                  dataKey={betType.BetType}
                  onChange={limitSetTableChangeHandler}
                  value={betType.Rebate}
                  fontSize="12px"
                  width={"80px"}
                />
              </td>
              <td
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                <TransparentTextInput
                  id="RebateOnline"
                  name="RebateOnline"
                  type="text"
                  dataKey={betType.BetType}
                  onChange={limitSetTableChangeHandler}
                  value={betType.RebateOnline}
                  fontSize="12px"
                  width={"80px"}
                />
              </td>
              <td
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                  width: "70px",
                }}
              >
                <input
                  key={"ToteBet" + i}
                  type="checkbox"
                  name="ToteBet"
                  checked={betType.ToteBet}
                  style={{ height: "15px", cursor: "pointer" }}
                  className="form-control"
                  onChange={() => handleChkToteBetChange(betType.BetType)}
                ></input>
              </td>
              <td
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                <TransparentTextInput
                  id="ToteThreshold"
                  name="ToteThreshold"
                  type="text"
                  dataKey={betType.BetType}
                  onChange={limitSetTableChangeHandler}
                  value={betType.ToteThreshold}
                  fontSize="12px"
                  width={"80px"}
                />
              </td>
              <td
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                  width: "70px",
                }}
              >
                <input
                  key={"UseAcumulativeLimit" + i}
                  type="checkbox"
                  name="UseAcumulativeLimit"
                  checked={betType.UseAcumulativeLimit}
                  style={{ height: "15px", cursor: "pointer" }}
                  className="form-control"
                  onChange={() =>
                    handleChkAccumulativeLimitChange(betType.BetType)
                  }
                ></input>
              </td>
            </>
          );
        }
      });
    }

    if (
      element.name !== "GrandSlam" &&
      element.name !== "ExactaBox" &&
      element.name !== "TrifectaBox" &&
      element.name !== "SuperfectaBox" &&
      element.name !== "QuinellaBox" &&
      element.name !== "HouseQBox"
    ) {
      colsWagerTypes.push(
        <tr
          key={element.id}
          onClick={() => setBetTypeInfo(element.id, element.name)}
          className={
            betTypeOptionSelected === element.id ? "classActiveMultiselect" : ""
          }
        >
          <td className="d-none">{element.id}</td>
          <td
            style={{
              background: "#212529",
              color: "#fff",
              verticalAlign: "middle",
              textAlign: "center",
            }}
          >
            {element.name}
          </td>
          {rowsBetTypes}
        </tr>,
      );
    }
  });

  return (
    <div className="mt-2">
      <div
        className="tableWTLimits"
        style={{
          overflow: "auto",
        }}
        ref={divRef}
      >
        <table className="table table-hover table-sm" ref={tableRef}>
          <thead
            style={{
              position: "sticky",
              top: "0",
              background: "#fff",
              fontSize: "13px",
            }}
          >
            {headers}
          </thead>
          <tbody className="table-lg">{colsWagerTypes}</tbody>
        </table>
      </div>
    </div>
  );
};

export default WagerTypesLimitTable;
